import React, { Component } from "react";
import "./Listing.css";

class Listing extends Component {
  render() {
    let listingData = this.props.listingData;

    return (
      <div className="listing">
        <div className="listing-thumbnail">
          <img src={listingData.thumbnail} alt="" />
        </div>
        <div className="listing-details">
          <div className="listing-title">
            {listingData.unit} {listingData.title}
          </div>
          <div className="bed-and-bath">
            {listingData.bedrooms +
              " bed " +
              listingData.bathrooms +
              " bath, " +
              listingData["sq-ft"] +
              " sqft"}
          </div>
          <div className="description">{listingData.body}</div>
          <div className="listing-external-buttons">
            {listingData.zillow !== "" && (
              <a
                href={listingData.zillow}
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Zillow
              </a>
            )}
            {listingData.craigslist !== "" && (
              <a
                href={listingData.craigslist}
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Craigslist
              </a>
            )}
            <span className="cost">{listingData.cost}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Listing;



// WEBPACK FOOTER //
// ./src/Listing.jsx